import script from "./LayersDesignGenerator.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayersDesignGenerator.vue?vue&type=script&setup=true&lang=ts"

import "./LayersDesignGenerator.vue?vue&type=style&index=0&id=bca433ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bca433ec"]])

export default __exports__